import { firestore as db } from "../../firebaseConfig";
import { collection, query, where,getDocs,doc ,onSnapshot, setDoc, getDoc, startAt } from "firebase/firestore";
export const collectionSnapShot=async(path,callback)=>{
    try {
        const q = query(collection(db, path));
       const unsubscribe = onSnapshot(q, (snapshot) => {
        snapshot.forEach((change) => {
            
        });
        });
    } catch (e) {
        console.log("error in getCollectionSnap",e);
    }
}
// get collection docs
export const getCollectionDocs=async(path)=>{
    try {
        const querySnapshot = await getDocs(collection(db, path));
        let list=[]
        querySnapshot.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
        // console.log(doc.id, " => ", doc.data());
        list.push(doc.data())
        });
        return {data:list,error:null}
    } catch (e) {
        console.log(e.message);
        return {data:null,error:"Something went wrong"}
    }
}
export const getPaginatedCollection=async(path,start,end)=>{
    const querySnapshot = await getDocs(collection(db, path),startAt());
}
export const getCollectionByCondition=async(path,filed,operator,value)=>{
    try {
        const collectionRef = collection(db, path);
        const q = query(collectionRef, where(filed, operator, value));
        const list=[];
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
        // console.log(doc.id, " => ", doc.data());
        list.push(doc.data())
        });
        return {data:list,error:null}

    } catch (e) {
        return{data:null,error:"Something went wrong" }
    }
}

//updata a doc
export const updateItem=async(path,docId,data)=>{
    try {
         const storeRef = doc(db,path , docId);
          await setDoc(storeRef, data, { merge: true });
          return true;        
    } catch (e) {
        return false
    }
}

export const createDoc=async(path,data,docId)=>{
    try {
        let docRef;
        if(!docId){
           docRef=doc(collection(db,path))  
        }else docRef=doc(collection(db,path,docId)) ;
        await setDoc(docRef,{
            ...data,
            id:docRef.id,
        })
        return true;
    } catch (e) {
        // console.log("err at creatinh Doc",e.message);
        return false;
    }
}
export const getDocById=async(path,id)=>{
    try {
        const docRef = doc(db, path, id);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            return {data:docSnap.data(),error:null}
            } else {
            return {data:null,error:"No such document!"}
            
            }
        // const unsub = onSnapshot(doc(db, path, id), (doc) => {
        //     callback(doc.data());
        // });
        // return unsub;
    } catch (e) {
        return {data:null,error:"Something went wrong, failed to load your data!"}
    }
}